module.exports = __webpack_public_path__ + "static/media/UserSettingsIcon.3d6431b6.png";